import { render, staticRenderFns } from "./ShortcutKey.vue?vue&type=template&id=37fe1232&scoped=true&"
import script from "./ShortcutKey.vue?vue&type=script&lang=js&"
export * from "./ShortcutKey.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutKey.vue?vue&type=style&index=0&id=37fe1232&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe1232",
  null
  
)

export default component.exports